export default __webpack_public_path__ + "static/media/twitter.92a0a463.svg";